import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import Layout from '../../components/Layout'
import Hidden from '@material-ui/core/Hidden'
import PostsLists from '../../components/PostsList'

import FollowNewsletter from '../../components/FollowNewsletter'
import FeaturedArticle from '../../components/FeaturedArticle'
import FeaturedCategories from '../../components/FeaturedCategories'
import Seo from '../../components/Seo'

const query = graphql`
	{
		allContentfulBlogPost(sort: { fields: createdAt, order: DESC }, skip: 1) {
			nodes {
				id
				title
				shortTitle
				createdAt(formatString: "MMM d")
				image {
					gatsbyImageData(
						layout: CONSTRAINED
						placeholder: DOMINANT_COLOR
						width: 152
					)
				}
				body {
					body
				}
				tags {
					tags
				}
			}
		}
	}
`

const useStyles = makeStyles((theme) => ({
	outerCtr: {
		paddingLeft: 50,
		paddingRight: 50,
		paddingTop: '1.5em',
		paddingBottom: '1.5em',
		[theme.breakpoints.up('lg')]: {
			paddingLeft: 10,
			maxWidth: '90%',
			marginLeft: 'auto',
			marginRight: 'auto',
			paddingRight: 10,
		},
		[theme.breakpoints.down('sm')]: {
			paddingLeft: 40,
			paddingRight: 40,
		},
		[theme.breakpoints.down('xs')]: {
			padding: '2em 16px',
		},
	},
	title: {
		color: theme.palette.common.accent,
		// color: 'red',
		fontSize: '1rem',
		fontWeight: 700,
		[theme.breakpoints.up('sm')]: {
			fontWeight: 500,
		},
	},
	lightTitle: {
		color: theme.palette.common.accent,
		fontSize: '1rem',
		fontWeight: 700,
		[theme.breakpoints.up('sm')]: {
			fontWeight: 500,
		},
	},
	shortTitle: {
		color: 'lightgrey',
	},
	lightShortTitle: {
		color: 'rgba(117, 117, 117, 1)',
	},
	tags: {
		color: 'grey',
		fontSize: '.8rem',
		marginBottom: 3,
		fontWeight: 400,
	},
	lightTags: {
		color: '#292929',
		fontSize: '.8rem',
		marginBottom: 3,
		fontWeight: 400,
	},
	date: {
		color: 'lightgrey',
		fontSize: '.8rem',
	},
	lightDate: {
		color: '#757575',
		fontSize: '.8rem',
	},
	gatsImage: {
		[theme.breakpoints.down('xs')]: {
			width: 100,
		},
	},
}))

export default function ArticlesIndex({ data }) {
	const {
		allContentfulBlogPost: { nodes: posts },
	} = useStaticQuery(query)
	const classes = useStyles()
	const theme = useTheme()
	const matchesXS = useMediaQuery(theme.breakpoints.down('xs'))
	const matchesMD = useMediaQuery(theme.breakpoints.only('md'))

	return (
		<Layout>
			<Seo title='Articles' />
			<Grid
				container
				justify={matchesMD ? 'center' : undefined}
				className={classes.outerCtr}
			>
				<Hidden lgUp>
					<Grid item md={10}>
						<FollowNewsletter />
					</Grid>
				</Hidden>

				<Grid item xs={12} md={10} lg={7}>
					<FeaturedArticle />
					<div style={{ paddingTop: matchesXS ? '0em' : '2em' }} />
					<PostsLists title={'Latest'} posts={posts} />
				</Grid>
				<Hidden mdDown>
					<Grid item lg={5}>
						<Grid container direction='column'>
							<Grid
								container
								justify='flex-start'
								style={{ paddingLeft: '2em' }}
							>
								<Grid item lg={8}>
									<FollowNewsletter />
								</Grid>
								<Grid item lg={8}>
									<FeaturedCategories posts={posts} />
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Hidden>
			</Grid>
		</Layout>
	)
}
